import { createApi } from '@reduxjs/toolkit/query/react';
import { customBaseQuery } from 'services/baseQuery';

export const systemSettingApi = createApi({
  baseQuery: customBaseQuery,
  reducerPath: 'campaignNotificationApi',
  tagTypes: ['CampaignNotifications'],
  endpoints: (builder) => ({
    getCampaignNotification: builder.query({
      query: () => ({
        url: '/system_setting',
        method: 'GET',
        params: { key: 'campaign-notification' }
      })
    }),
  })
});

export const {
  usePrefetch,
  useGetCampaignNotificationQuery,
} = systemSettingApi;
